import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admin-spinner',
    templateUrl: './admin-spinner.component.html',
    styleUrls: ['./admin-spinner.component.scss'],
    standalone: false
})
export class AdminSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
